import React from 'react';
import styled, { css } from 'styled-components';
import { IndicatorLayoutComponentProps, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useLang } from '@shapeable/ui';
import { ValueBubble } from '../elements/value-bubble';
import { classNames } from '@shapeable/utils';
const cls = classNames('indicator-layout-value-bubble');

export type IndicatorLayoutValueBubbleProps = IndicatorLayoutComponentProps & {
};

export const IndicatorLayoutValueBubbleDefaultProps: Omit<IndicatorLayoutValueBubbleProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    justify-content: center;
    display: flex;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    flex-direction: column;
    padding: ${theme.UNIT(4)} ${theme.UNIT(3)} ${theme.UNIT(3)} ${theme.UNIT(3)};
    font-size: ${theme.FONT_SIZE(13)};
    flex-grow: 1;
    position: relative;
    box-sizing: border-box;
  `,
  tablet: css`
    font-size: ${theme.FONT_SIZE(14)};
  `,
  desktop: css`
    font-size: ${theme.FONT_SIZE(15)};
  `,
});

const ValueStyles = breakpoints({
  base: css`
    margin-top: ${theme.UNIT(2)};
    align-self: center;
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Value: styled(ValueBubble)`${ValueStyles}`,
};

export const IndicatorLayoutValueBubble: Shapeable.FC<IndicatorLayoutValueBubbleProps> = (props) => {
  const { className, children, entity } = props;
  const t = useLang();

  const { result } = entity || {};
  const { indicator } = result || {};

  const unit = indicator?.unit?.shorthand || indicator?.unit?.name;

  return (
    <My.Container className={className}>
      <My.Value value={result?.numericValue} name={t(entity?.name)} unit={t(`(${unit})`)} /> 
    </My.Container>
  )
};

IndicatorLayoutValueBubble.defaultProps = IndicatorLayoutValueBubbleDefaultProps;
IndicatorLayoutValueBubble.cls = cls;